// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SaveFilledSvg from "@ant-design/icons-svg/es/asn/SaveFilled";
import AntdIcon from '../components/AntdIcon';

var SaveFilled = function SaveFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SaveFilledSvg
  }));
};

SaveFilled.displayName = 'SaveFilled';
export default React.forwardRef(SaveFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/SaveFilled.js
// module id = 1747
// module chunks = 0